import React, { useState } from "react";

const hours = [1,2,3,4,5,6,7,8,9,10,11,12];
const minutes = [0,5,10,15,20,25,30,35,40,45,50,55];

export default function TimePickerBottomSheet({ open, onClose, onSelect, initialValue }) {
  const [ampm, setAmpm] = useState(initialValue?.ampm || "오후");
  const [hour, setHour] = useState(initialValue?.hour || 1);
  const [minute, setMinute] = useState(initialValue?.minute || 0);

  if (!open) return null;

  return (
    <div style={{
      position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 1000,
      background: "#fff", borderTopLeftRadius: 16, borderTopRightRadius: 16, boxShadow: "0 -2px 16px rgba(0,0,0,0.08)", padding: 24
    }}>
      <div style={{ width: 40, height: 4, background: "#ccc", borderRadius: 2, margin: "0 auto 12px" }} />
      <div style={{ textAlign: "center", fontWeight: 500, marginBottom: 16 }}>시간 알림</div>
      {/* 오전/오후 토글 */}
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
        {["오전", "오후"].map(type => (
          <button
            key={type}
            onClick={() => setAmpm(type)}
            style={{
              width: 100, height: 36, borderRadius: 18, border: "none",
              background: ampm === type ? "#000" : "#eee",
              color: ampm === type ? "#fff" : "#000",
              fontWeight: 500, marginRight: type === "오전" ? 8 : 0, fontSize: 16
            }}
          >{type}</button>
        ))}
      </div>
      {/* 시/분 선택 */}
      <div style={{ display: "flex", justifyContent: "center", gap: 32 }}>
        {/* 시 */}
        <div>
          <div style={{ marginBottom: 8, textAlign: "center" }}>시</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 36px)", gap: 12 }}>
            {hours.map(h => (
              <button
                key={h}
                onClick={() => setHour(h)}
                style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: hour === h ? "#000" : "#f5f5f5",
                  color: hour === h ? "#fff" : "#000",
                  border: "none", fontSize: 16, fontWeight: 500
                }}
              >{h}</button>
            ))}
          </div>
        </div>
        {/* 분 */}
        <div>
          <div style={{ marginBottom: 8, textAlign: "center" }}>분</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 36px)", gap: 12 }}>
            {minutes.map(m => (
              <button
                key={m}
                onClick={() => setMinute(m)}
                style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: minute === m ? "#000" : "#f5f5f5",
                  color: minute === m ? "#fff" : "#000",
                  border: "none", fontSize: 16, fontWeight: 500
                }}
              >{m.toString().padStart(2, "0")}</button>
            ))}
          </div>
        </div>
      </div>
      {/* 완료 버튼 */}
      <button
        onClick={() => { onSelect({ ampm, hour, minute }); onClose(); }}
        style={{
          width: "100%", marginTop: 32, height: 44, borderRadius: 8,
          background: "#f5f5f5", border: "none", fontWeight: 500, fontSize: 18
        }}
      >완료</button>
    </div>
  );
}